import {useMaterialsRecipes as useDomainMaterialsRecipes} from '@domain/materials'
import {AssetType} from '@hconnect/common/types'

import {useUrlParam} from '../../../routing'

export const useMaterialsRecipes = (assetType?: AssetType) => {
  const plantCode = useUrlParam('plantCode')
  return useDomainMaterialsRecipes({
    plantCode,
    assetType,
    options: {
      enabled: Boolean(assetType)
    }
  })
}
